import type {IconProps} from '@smart/web-components';
import {Icon, Text} from '@smart/web-components';
import React from 'react';
import styles from './index.module.scss';

export type HighlightProps = {
  iconName?: IconProps['name'];
  text: string;
  colorIcon?: {
    url: string;
    alt: string;
  };
  disclaimerRef?: string;
};

export const Highlight = ({
  colorIcon,
  disclaimerRef,
  iconName,
  text,
}: HighlightProps) => {
  return (
    <div className={styles.highlight}>
      {(iconName || colorIcon) && (
        <div className={styles.highlightIcon}>
          {iconName && <Icon name={iconName} />}
          {colorIcon && (
            <img
              className={styles.highlightColorTile}
              src={colorIcon.url}
              alt={colorIcon.alt}
            />
          )}
        </div>
      )}
      <Text variant="paragraph-100">
        {text}
        {disclaimerRef && <sup>{disclaimerRef}</sup>}
      </Text>
    </div>
  );
};
